import styled from 'styled-components/native'

interface VideoContainerProps {
  isReady: boolean
}

export const VideoContainer = styled.View<VideoContainerProps>`
  flex: 1;
  transition: opacity ease-in-out 0.5s;
  opacity: ${(props) => (props.isReady ? 1 : 0)};
  object-fit: cover;
`
